<template>
    <button class="NextButton" @click="nextQuestion()">
        {{ ( next == "results" ? "Results" : "Next" ) }}
    </button>
</template>

<script>

    export default {
        name: "NextButton",
        props: {
            next: [Number, String]
        },
        methods: {
            nextQuestion() {
                if (this.next == "results") {
                    this.$router.push(this.next);
                } else {
                    this.$store.commit('update', { name: 'step', value: this.next });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .NextButton {
        display: inline-block;
        width: auto;
        background-color: #FFCD05;
        border-radius: 4px;
        color: #000 !important;
        font-family: 'AtlasGrotesk-Medium-Web', Helvetica, Arial, sans-serif;
        font-size: 16px;
        padding: 1em 3.75em;
        cursor: pointer;
        border: none;
    }
</style>
